__turbopack_context__.v({
  "burger": "navbar-module__CtdzVa__burger",
  "burger-button": "navbar-module__CtdzVa__burger-button",
  "desktop-nav": "navbar-module__CtdzVa__desktop-nav",
  "nav": "navbar-module__CtdzVa__nav",
  "nav-link": "navbar-module__CtdzVa__nav-link",
});
